'use strict';

var _ = require('lodash');
var GridToolbarFaresContributingFBCsController = function GridToolbarFaresContributingFBCsController($scope) {
  function isRowModified(row) {
    if (!row._old) {
      // no modificatons in grid for this row
      return false;
    }

    // check if user modified undefined to null
    if (row._old.userFare === undefined && row.userFare === null) {
      delete row.userFare;
    }
    if (row._old.userTraffic === undefined && row.userTraffic === null) {
      delete row.userTraffic;
    }
    return row.userFare !== undefined || row.userTraffic !== undefined;
  }
  $scope.saveChanges = function () {
    var rows = _.chain($scope.jqxGridSettings.source.loadedData).filter(isRowModified).clone(true).value(true);
    if (rows.length > 0) {
      $scope.$emit('fares-contributing-fbcs-grid:saveChanges', rows);
    } else {
      $scope.clearModifiedCells();
    }
  };
  $scope.$on('fares-contributing-fbcs-grid:saveSuccess', function () {
    $scope.clearModifiedCells();
  });
};
GridToolbarFaresContributingFBCsController.$inject = ['$scope'];
module.exports = GridToolbarFaresContributingFBCsController;